// mobile/utils/authStorage.js
import { Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

let AsyncStorage = null;

// Lazy require untuk native (hindari bundler error di web)
if (!isWeb) {
  try {
    // gunakan eval supaya bundler web tidak resolve module ini
    const _req = (0, eval)('require');
    const mod = _req('@react-native-async-storage/async-storage');
    AsyncStorage = mod?.default || mod;
  } catch {
    AsyncStorage = null;
  }
}

const hasLocalStorage =
  isWeb && typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const mem = new Map();

export const authStorage = {
  async get(key) {
    if (AsyncStorage) return AsyncStorage.getItem(key);
    if (hasLocalStorage) return window.localStorage.getItem(key);
    return mem.get(key) ?? null;
  },
  async set(key, val) {
    const str = typeof val === 'string' ? val : String(val);
    if (AsyncStorage) return AsyncStorage.setItem(key, str);
    if (hasLocalStorage) return window.localStorage.setItem(key, str);
    mem.set(key, str);
  },
  async remove(key) {
    if (AsyncStorage) return AsyncStorage.removeItem(key);
    if (hasLocalStorage) return window.localStorage.removeItem(key);
    mem.delete(key);
  },
  async multiRemove(keys = []) {
    if (AsyncStorage && typeof AsyncStorage.multiRemove === 'function') {
      return AsyncStorage.multiRemove(keys);
    }
    if (hasLocalStorage) {
      keys.forEach((k) => window.localStorage.removeItem(k));
      return;
    }
    keys.forEach((k) => mem.delete(k));
  },
};

